import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useEVChargerStore } from './useEVChargerStore';
import { RoutesList } from '../app/routes/Routes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const submitData = async (payload: any) => {
  const urlPath = '/report/v1/vehicles/charging-point';
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APIM_BASE_URL}${urlPath}`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY as string}`,
          'content-type': 'application/json',
        },
      },
    );
    const submitResponse = await response.json();
    if (!submitResponse || !submitResponse.case_reference) {
      throw new Error('Failed to submit report');
    }
    return submitResponse;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useHandleSubmit = () => {
  const navigate = useNavigate();
  const { update } = useEVChargerStore();

  return useMutation({
    mutationFn: submitData,
    onSuccess: (data) => {
      if (data && data.case_reference) {
        update('caseReferenceId', data.case_reference);
      }
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(RoutesList.INTERNAL_SERVER_ERROR);
    },
  });
};
